import {
  FiHome,
  FiEdit3,
  FiBriefcase,
  FiCompass,
  FiHeart,
  FiFolder,
  FiUsers,
  FiUser,
  FiKey,
  FiTrendingUp,
} from "react-icons/fi";

const createItem = (item) => ({
  ...item,
  activePrefixes: item.activePrefixes ?? [item.to],
});

export const PARTNER_PANEL_HOME = "/partner/dashboard";

export const partnerSidebarSections = [
  {
    id: "overview",
    title: "Overview",
    items: [
      {
        to: "/partner/dashboard",
        label: "Dashboard",
        icon: FiHome,
        activePrefixes: ["/partner/dashboard", "/partner/myspace"],
      },
    ],
  },
  {
    id: "shared",
    title: "Shared",
    items: [
      {
        to: "/partner/posts",
        label: "Shared Posts",
        icon: FiEdit3,
        activePrefixes: ["/partner/posts"],
      },
      {
        to: "/partner/properties",
        label: "Shared Properties",
        icon: FiBriefcase,
        activePrefixes: ["/partner/properties"],
      },
      {
        to: "/partner/promotions",
        label: "Shared Promotions",
        icon: FiTrendingUp,
        activePrefixes: ["/partner/promotions"],
      },
      {
        to: "/partner/shared-leads",
        label: "Shared Leads",
        icon: FiCompass,
        activePrefixes: ["/partner/shared-leads"],
      },
    ],
  },
  {
    id: "myspace",
    title: "My Space",
    items: [
      {
        to: "/partner/my-properties",
        label: "My Properties",
        icon: FiBriefcase,
        activePrefixes: ["/partner/my-properties"],
      },
      {
        to: "/partner/my-posts",
        label: "My Posts",
        icon: FiEdit3,
        activePrefixes: ["/partner/my-posts"],
      },
      {
        to: "/partner/leases",
        label: "Lease Management",
        icon: FiKey,
        activePrefixes: ["/partner/leases"],
      },
      {
        to: "/partner/saved",
        label: "Following",
        icon: FiHeart,
        activePrefixes: ["/partner/saved", "/partner/following"],
      },
      {
        to: "/partner/shared-with-me",
        label: "Shared with Me",
        icon: FiFolder,
        activePrefixes: ["/partner/shared-with-me"],
      },
    ],
  },
  {
    id: "people",
    title: "People",
    items: [
      {
        to: "/partner/friends",
        label: "Friends",
        icon: FiUsers,
        activePrefixes: ["/partner/friends"],
      },
      {
        to: "/partner/agents",
        label: "Agents & Associates",
        icon: FiUser,
        activePrefixes: ["/partner/agents"],
      },
    ],
  },
].map((section) => ({
  ...section,
  items: section.items.map(createItem),
}));

export const getPartnerPageTitle = (pathname) => {
  const allItems = partnerSidebarSections.flatMap((s) => s.items);
  const found = allItems.find((item) =>
    item.activePrefixes.some(
      (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`)
    )
  );
  return found?.label ?? "Partner Dashboard";
};

const partnerNavigation = {
  sections: partnerSidebarSections,
};

export default partnerNavigation;
